import { render, staticRenderFns } from "./ModalSearch_Search.vue?vue&type=template&id=5d61844d"
import script from "./ModalSearch_Search.vue?vue&type=script&lang=js"
export * from "./ModalSearch_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports